import { defineMessages } from 'react-intl';

export const accountPermissionsMessages = defineMessages({
  save: {
    id: 'account.permissions.save',
    defaultMessage: 'Save permissions',
  },
  saveSuccess: {
    id: 'account.permissions.saveSuccess',
    defaultMessage: 'Permissions saved',
  },
  selfLockoutTitle: {
    id: 'account.permissions.selfLockoutTitle',
    defaultMessage: 'Remove your own access?',
  },
  selfLockoutContent: {
    id: 'account.permissions.selfLockoutContent',
    defaultMessage:
      'You are removing your own admin access or the right to edit permissions. You will not be able to restore them yourself.',
  },
});

export const adminPermissionGroupMessages = defineMessages({
  apiKeys: {
    id: 'account.permissions.group.apiKeys',
    defaultMessage: 'API keys',
  },
  systemLoad: {
    id: 'account.permissions.group.systemLoad',
    defaultMessage: 'System load',
  },
  adminAccess: {
    id: 'account.permissions.group.adminAccess',
    defaultMessage: 'Admin access management',
  },
  twoStepVerification: {
    id: 'account.permissions.group.twoStepVerification',
    defaultMessage: 'Two-step verification',
  },
  other: {
    id: 'account.permissions.group.other',
    defaultMessage: 'Other',
  },
});

export const adminPermissionFlagMessages = defineMessages({
  BasicAccess: {
    id: 'account.permissions.BasicAccess',
    defaultMessage: 'Admin panel access (basic)',
  },
  APIKeyCanView: {
    id: 'account.permissions.APIKeyCanView',
    defaultMessage: 'View API keys',
  },
  APIKeyCanDelete: {
    id: 'account.permissions.APIKeyCanDelete',
    defaultMessage: 'Delete API keys',
  },
  APIKeyCanCreate: {
    id: 'account.permissions.APIKeyCanCreate',
    defaultMessage: 'Create API keys',
  },
  SystemLoadCanView: {
    id: 'account.permissions.SystemLoadCanView',
    defaultMessage: 'View system load',
  },
  SystemLoadCanChange: {
    id: 'account.permissions.SystemLoadCanChange',
    defaultMessage: 'Change system load',
  },
  AdminPermissionsCanEdit: {
    id: 'account.permissions.AdminPermissionsCanEdit',
    defaultMessage: 'Edit admin permissions',
  },
  FeatureFlagsCanEdit: {
    id: 'account.permissions.FeatureFlagsCanEdit',
    defaultMessage: 'Edit feature flags',
  },
  BillingCanEditInventory: {
    id: 'account.permissions.BillingCanEditInventory',
    defaultMessage: 'Manage billing products and orders',
  },
  BillingZoneCanEdit: {
    id: 'account.permissions.BillingZoneCanEdit',
    defaultMessage: 'Edit billing zones',
  },
  MFACanView: {
    id: 'account.permissions.MFACanView',
    defaultMessage: 'View two-step verification status',
  },
  MFACanEnforce: {
    id: 'account.permissions.MFACanEnforce',
    defaultMessage: 'Require two-step verification for a user',
  },
  MFACanSetup: {
    id: 'account.permissions.MFACanSetup',
    defaultMessage: 'Remove a user’s two-step verification',
  },
  MFACanEditAdmin: {
    id: 'account.permissions.MFACanEditAdmin',
    defaultMessage: 'Manage two-step verification of admin accounts',
  },
  DistributorsCanManage: {
    id: 'account.permissions.DistributorsCanManage',
    defaultMessage: 'Manage distributors',
  },
  DSOCanManage: {
    id: 'account.permissions.DSOCanManage',
    defaultMessage: 'Manage DSO',
  },
  StatisticsCanViewForAllOrganization: {
    id: 'account.permissions.StatisticsCanViewForAllOrganization',
    defaultMessage: 'View statistics (all organizations)',
  },
  AdminPermissionsCanView: {
    id: 'account.permissions.AdminPermissionsCanView',
    defaultMessage: 'View admin permissions',
  },
});
